import { Button, Empty } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import Table from '../../components/Table/Basic';
import Date from '../../components/Formatter/Date';
import DeleteButton from './DeleteButton';

const Index = () => {
  const [loading, setLoading] = useState(true);
  const [trainings, setTrainings] = useState([]);
  const [total, setTotal] = useState(null);
  const params = useContext(ParamsContext);

  const [divisionOptions, setDivisionOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [trainingCategoryOptions, setTrainingCategoryOptions] = useState([]);
  const [trainingFieldOptions, setTrainingFieldOptions] = useState([]);

  useEffect(() => {
    fetchTrainingList();
  }, [params]);

  useEffect(() => {
    fetchDivisionOptions();
    fetchProjectOptions(params.division);
    fetchVendorOptions();
    fetchTrainingCategoryOptions();
    fetchTrainingFieldOptions(params.category);
  }, []);

  const fetchTrainingList = () => {
    setLoading(true);
    const url = `/training/list`;
    axios.get(url, { params: params }).then(resp => {
      setTrainings(resp.data.training);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  const fetchDivisionOptions = () => {
    const url = `/master/divisions`;
    axios.get(url).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: `${item.id}`, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setDivisionOptions(options);
    }).catch(err => {});
  }

  const fetchProjectOptions = (division) => {
    const url = `/master/projects`;
    axios.get(url, { params: division ? { division: division } : {} }).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: `${item.id}`, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setProjectOptions(options);
    }).catch(err => {});
  }

  const fetchVendorOptions = () => {
    const url = `/master/vendors`;
    axios.get(url).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: item.id, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setVendorOptions(options);
    }).catch(err => {});
  }

  const fetchTrainingCategoryOptions = () => {
    const url = `/master/training-categories`;
    axios.get(url).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: `${item.id}`, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setTrainingCategoryOptions(options);
    }).catch(err => {});
  }

  const fetchTrainingFieldOptions = (category) => {
    const url = `/master/training-fields`;
    axios.get(url, { params: category ? { category: category } : {} }).then(resp => {
      const options = resp.data.reduce((arr, item) => {
        return [...arr, { value: `${item.id}`, label: item.name }];
      }, [{ value: '', label: 'Semua' }]);
      setTrainingFieldOptions(options);
    }).catch(err => {});
  }

  const columns = [
    {
      title: "Nama",
      key: "name",
      filter: true,
      render: record => record.passport.name,
    },
    {
      title: "Divisi",
      key: 'division',
      filter: true,
      filterOptions: divisionOptions,
      onFilterChange: fetchProjectOptions,
      render: record => record.current_project.division.label
    },
    {
      title: "Proyek",
      key: 'project',
      filter: true,
      filterOptions: projectOptions,
      render: record => record.current_project.project.name
    },
    {
      title: "Perusahaan",
      key: "vendor",
      filter: true,
      filterOptions: vendorOptions,
      render: record => record.passport.vendor.name,
    },
    {
      title: "Tanggal Training",
      key: 'start_date',
      render: record => <Date value={record.date}/>
    },
    {
      title: "Berlaku Sampai",
      key: 'expiry_date',
      render: record => <Date value={record.expiry_date}/>
    },
    {
      title: "Jenis Training",
      key: 'type',
      filter: true,
      filterOptions: [
        {value: '', label: 'Semua'},
        {value: '1', label: 'Internal'},
        {value: '2', label: 'Eksternal'},
      ],
      render: record => record.type.label
    },
    {
      title: "Bidang Training",
      key: 'category',
      filter: true,
      filterOptions: trainingCategoryOptions,
      onFilterChange: fetchTrainingFieldOptions,
      render: record => record.field.category.name
    },
    {
      title: "Judul Training",
      key: 'title',
      filter: true,
      filterOptions: trainingFieldOptions,
      render: record => record.field.title
    },
    {
      title: "Status",
      key: 'status',
      render: record => record.status.label
    },
    {
      title: "",
      key: 'action',
      render: record => {
        return (
          <>
            <DeleteButton id={record.id}/>
          </>
        );
      }
    }
  ];

  return (
    <Auxiliary>
      <Title>Data Training</Title>
      <Link to={`/training/create`}><Button type="primary">Update Data Training</Button></Link>

      <div className="gx-mt-2">
        <Table
          columns={columns}
          dataSource={trainings}
          loading={loading}
          total={total}
          showSorterTooltip
          pathname="/training"
          sticky
        />
      </div>
    </Auxiliary>
  );
}

export default Index;